module.exports = __webpack_public_path__ + "static/media/logoBigPurple.7a9deba1.png";